import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/admin-theme.css'
import axios from 'axios'
import { API_BASE_URL } from './config/api'

axios.defaults.baseURL = API_BASE_URL

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
